<div class="toggleOptionRow" khA11ySwitch>
  <div class="toggleOptionDescription">
    <label class="title" khA11yLabelSource>{{title}}</label>
    <label class="description" khA11yDescriptionSource>{{description}}</label>
  </div>
  <div class="toggleOptionsSwitch">
    <div class="switchContainer">
      <kh-switch [formControl]="control" [testId]="testId" (isChecked)="isChecked.emit($event)"></kh-switch>
    </div>
  </div>
</div>
